import { forwardRef, useEffect, useState } from 'react';
import { clsx } from 'clsx';
import { useDebounce } from '@shared/hooks';
import { Icon } from '@shared/widgets/icon';
import SearchIcon from '@assets/icons/search.svg';
import styles from './styles.module.css';

interface ISearchInputProps {
  className?: string;
  value?: string;
  onChange: (data: string) => void;
  onKeyDown?: (event: React.KeyboardEvent<HTMLInputElement>) => void;
  isReadOnly?: boolean;
}

export const SearchInput = forwardRef<HTMLInputElement, ISearchInputProps>((props, ref) => {
  const [searchValue, setSearchValue] = useState<string>(props.value || '');
  const debouncedSearchValue = useDebounce(searchValue, 300);

  useEffect(() => {
    props.onChange(debouncedSearchValue);
  }, [debouncedSearchValue]);

  return (
    <div className={clsx('flex relative', styles.inputWrapper, props.className)}>
      <input
        ref={ref}
        className={clsx(
          'flex w-full h-10 p-2 pl-10 rounded border-b border-b-light focus:border-b-primary bg-ice dark:bg-soft-black hover:bg-white focus:outline-none font-light focus:font-normal text-sm focus:text-soft-black dark:focus:text-white',
          styles.input,
        )}
        placeholder='Search'
        onKeyDown={props.onKeyDown}
        value={searchValue}
        onChange={(e) => setSearchValue(e.target.value)}
        readOnly={props.isReadOnly}
      />
      <Icon icon={<SearchIcon />} className={clsx('absolute top-[10px] left-3', styles.searchIcon)} color='light' />
    </div>
  );
});
